var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSflLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "504px",
    height: "139px",
    viewBox: "0 0 504 139",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M107.504,107.391l-1.652,3.749h-1.8l6.65-14.823h1.758l6.628,14.823h-1.842l-1.652-3.749H107.504z     M111.527,98.243l-3.303,7.518h6.648L111.527,98.243z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M160.097,97.947v5.208h6.924v1.631h-6.924v6.353h-1.694V96.316h9.423v1.631H160.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M192.544,106.417c-0.317,0.021-0.656,0.042-0.995,0.042h-3.939v4.681h-1.693V96.316h5.632    c3.705,0,5.845,1.821,5.845,4.976c0,2.456-1.186,4.108-3.324,4.807l3.472,5.04h-1.927L192.544,106.417z M191.549,104.829    c2.689,0,4.215-1.186,4.215-3.494c0-2.245-1.526-3.387-4.215-3.387h-3.939v6.882H191.549z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M218.513,97.947v4.869h7.476v1.631h-7.476v5.082h8.641v1.61H216.82V96.316h10.058v1.631H218.513z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M247.892,97.947v4.869h7.476v1.631h-7.476v5.082h8.64v1.61h-10.334V96.316h10.058v1.631H247.892z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M282.204,106.417c-0.318,0.021-0.657,0.042-0.995,0.042h-3.939v4.681h-1.694V96.316h5.634    c3.705,0,5.845,1.821,5.845,4.976c0,2.456-1.186,4.108-3.326,4.807l3.473,5.04h-1.927L282.204,106.417z M281.209,104.829    c2.689,0,4.214-1.186,4.214-3.494c0-2.245-1.524-3.387-4.214-3.387h-3.939v6.882H281.209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M329.566,97.947v5.208h6.925v1.631h-6.925v6.353h-1.693V96.316h9.423v1.631H329.566z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M367.499,105.04c0,3.855-2.329,6.184-6.205,6.184c-3.895,0-6.247-2.329-6.247-6.184v-8.724h1.694v8.724    c0,2.881,1.737,4.553,4.553,4.553c2.817,0,4.51-1.672,4.51-4.553v-8.724h1.694V105.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M391.754,97.947v13.192h-1.694V97.947h-4.829v-1.631h11.371v1.631H391.754z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M426.764,105.04c0,3.855-2.329,6.184-6.205,6.184c-3.895,0-6.247-2.329-6.247-6.184v-8.724h1.694v8.724    c0,2.881,1.737,4.553,4.553,4.553c2.817,0,4.51-1.672,4.51-4.553v-8.724h1.694V105.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M453.136,106.417c-0.317,0.021-0.656,0.042-0.995,0.042h-3.939v4.681h-1.693V96.316h5.632    c3.705,0,5.845,1.821,5.845,4.976c0,2.456-1.186,4.108-3.324,4.807l3.472,5.04h-1.927L453.136,106.417z M452.141,104.829    c2.689,0,4.215-1.186,4.215-3.494c0-2.245-1.526-3.387-4.215-3.387h-3.939v6.882H452.141z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M479.105,97.947v4.869h7.476v1.631h-7.476v5.082h8.641v1.61h-10.334V96.316h10.058v1.631H479.105z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M114.979,56.837c0-1.365-0.058-2.9-0.456-4.095c-0.397-1.137-1.023-1.933-1.99-1.933    c-1.593,0.057-2.104,1.706-2.104,4.151c0,1.421,0.626,2.9,1.535,4.492c0.909,1.592,2.104,3.242,3.299,5.004    c1.421,2.104,2.843,4.265,3.924,6.369c1.081,2.104,1.818,4.265,1.818,6.539c0,2.786-0.453,5.402-1.762,7.336    c-1.309,1.934-3.411,3.184-6.766,3.184c-3.924,0-6.142-1.478-7.393-3.753c-1.251-2.275-1.535-5.289-1.535-8.416l6.028-0.569    c0,1.763,0.058,3.526,0.511,4.834c0.4,1.364,1.081,2.274,2.39,2.274c1.818,0,2.502-1.934,2.502-4.606    c0-1.364-0.684-2.957-1.593-4.606c-0.512-0.796-1.023-1.649-1.593-2.502c-1.193-1.706-2.501-3.639-3.866-5.743    c-1.364-2.104-2.388-4.265-3.013-6.483c-0.342-1.08-0.512-2.218-0.512-3.355c0-2.274,0.512-4.719,1.82-6.596    c1.307-1.82,3.297-3.128,6.198-3.185c3.697-0.056,5.857,1.478,7.052,3.696c1.193,2.275,1.534,5.061,1.534,7.393L114.979,56.837z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M123.966,51.947v-6.312h17.741v6.312h-5.8v35.483h-6.14V51.947H123.966z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M162.24,45.635v33.209c-0.058,1.706-0.4,3.242-1.025,4.549c-0.512,1.138-1.309,2.218-2.446,3.071    c-1.137,0.91-2.671,1.421-4.719,1.421s-3.639-0.512-4.778-1.421c-1.137-0.853-1.875-1.933-2.387-3.071    c-0.626-1.307-0.968-2.843-1.025-4.549V45.635h6.142v33.209c0,1.194,0.284,1.991,0.853,2.616    c0.284,0.284,0.683,0.455,1.195,0.455c1.079,0,1.592-0.683,1.82-1.535c0.17-0.398,0.228-0.91,0.228-1.535V45.635H162.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M168.553,87.431V45.635h4.836c5.686,0,8.756,1.137,10.406,4.322c1.592,3.184,1.818,8.416,1.818,16.604    s-0.227,13.363-1.818,16.547c-1.649,3.185-4.72,4.322-10.406,4.322H168.553z M174.695,81.289c2.105,0,3.299-0.227,3.924-2.274    c0.284-0.967,0.512-2.445,0.569-4.436c0.058-1.99,0.058-4.662,0.058-8.075c0-3.412,0-6.085-0.058-8.075    c-0.056-1.934-0.284-3.412-0.569-4.436c-0.625-1.99-1.818-2.217-3.924-2.217V81.289z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M191.532,45.635h14.045v6.312h-7.904v10.975h5.686v6.71h-5.686v11.487h7.904v6.312h-14.045V45.635z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M217.294,65.652l-0.512-1.934h-0.341v23.713h-5.629V45.635h5.458l5.971,21.779l0.511,1.934h0.342V45.635    h5.629v41.795h-5.459L217.294,65.652z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M232.935,51.947v-6.312h17.741v6.312h-5.8v35.483h-6.14V51.947H232.935z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M265.067,56.837c0-1.365-0.058-2.9-0.456-4.095c-0.397-1.137-1.023-1.933-1.99-1.933    c-1.593,0.057-2.104,1.706-2.104,4.151c0,1.421,0.626,2.9,1.535,4.492c0.909,1.592,2.104,3.242,3.299,5.004    c1.421,2.104,2.843,4.265,3.924,6.369c1.081,2.104,1.818,4.265,1.818,6.539c0,2.786-0.453,5.402-1.762,7.336    c-1.309,1.934-3.411,3.184-6.766,3.184c-3.924,0-6.142-1.478-7.393-3.753c-1.251-2.275-1.535-5.289-1.535-8.416l6.028-0.569    c0,1.763,0.058,3.526,0.511,4.834c0.4,1.364,1.081,2.274,2.39,2.274c1.818,0,2.502-1.934,2.502-4.606    c0-1.364-0.684-2.957-1.593-4.606c-0.512-0.796-1.023-1.649-1.593-2.502c-1.193-1.706-2.501-3.639-3.866-5.743    c-1.364-2.104-2.388-4.265-3.013-6.483c-0.342-1.08-0.512-2.218-0.512-3.355c0-2.274,0.512-4.719,1.82-6.596    c1.307-1.82,3.297-3.128,6.198-3.185c3.697-0.056,5.857,1.478,7.052,3.696c1.193,2.275,1.534,5.061,1.534,7.393L265.067,56.837z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M301.407,51.947h-8.472v10.975h5.686v6.312h-5.686v18.197h-6.142V45.635h14.614V51.947z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M321.712,78.844c-0.058,1.706-0.4,3.242-1.025,4.549c-0.512,1.138-1.309,2.218-2.446,3.071    c-1.137,0.91-2.671,1.421-4.719,1.421c-2.048,0-3.639-0.512-4.776-1.421c-1.139-0.853-1.876-1.933-2.388-3.071    c-0.625-1.307-0.967-2.843-1.025-4.549V54.222c0.058-1.649,0.4-3.185,1.025-4.493c0.512-1.137,1.25-2.274,2.388-3.127    c1.137-0.854,2.729-1.422,4.776-1.422c2.048,0,3.582,0.569,4.719,1.422c1.137,0.853,1.934,1.99,2.446,3.127    c0.625,1.308,0.967,2.843,1.025,4.493V78.844z M315.57,54.222c0-1.138-0.228-1.934-0.797-2.616    c-0.284-0.284-0.74-0.455-1.251-0.455c-1.081,0-1.592,0.796-1.82,1.535c-0.172,0.455-0.228,0.966-0.228,1.535v24.622    c0,1.194,0.284,1.991,0.853,2.616c0.284,0.284,0.684,0.455,1.195,0.455c1.079,0,1.592-0.683,1.82-1.535    c0.17-0.398,0.228-0.91,0.228-1.535V54.222z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M338.659,87.431l-3.183-17.628h-1.649v17.628h-6.142V45.635h6.142c7.335,0,10.463,4.151,10.463,12.055    c0,4.151-1.081,7.904-3.413,9.497l3.924,20.244H338.659z M333.826,64.116c0.853,0,1.99-0.114,2.901-0.91    c0.911-0.797,1.648-2.331,1.648-5.289c0-2.957-0.737-4.549-1.648-5.345c-0.911-0.796-2.048-0.853-2.901-0.853V64.116z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M360.613,45.635h6.142v36.109h8.132v5.686h-14.273V45.635z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M379.212,45.635h6.142v41.795h-6.142V45.635z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M391.723,87.431V45.635h5.403c3.639,0,6.482,0.683,8.358,2.445c1.877,1.763,2.844,4.492,2.844,8.643    c0,1.991-0.17,3.469-0.797,4.833c-0.626,1.365-1.592,2.502-3.013,3.81c1.534,0.853,2.671,2.445,3.583,5.118    c0.453,1.308,0.681,3.014,0.681,5.118c0,3.128-0.569,5.914-1.99,8.075c-1.421,2.161-3.867,3.583-7.507,3.753H391.723z     M397.865,62.865c0.512,0,1.706,0.057,2.73-0.626c1.023-0.683,1.818-2.047,1.818-4.947c0-2.9-0.795-4.265-1.818-4.947    c-1.025-0.683-2.218-0.626-2.73-0.626V62.865z M397.865,81.346c0.512,0,1.706,0.114,2.73-0.626    c1.023-0.739,1.818-2.388,1.818-5.8c0-3.412-0.795-5.061-1.818-5.8c-1.025-0.739-2.218-0.626-2.73-0.626V81.346z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M414.246,45.635h14.045v6.312h-7.904v10.975h5.686v6.71h-5.686v11.487h7.904v6.312h-14.045V45.635z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M444.501,87.431l-3.185-17.628h-1.649v17.628h-6.14V45.635h6.14c7.336,0,10.463,4.151,10.463,12.055    c0,4.151-1.081,7.904-3.411,9.497l3.924,20.244H444.501z M439.667,64.116c0.853,0,1.991-0.114,2.9-0.91    c0.909-0.797,1.649-2.331,1.649-5.289c0-2.957-0.74-4.549-1.649-5.345s-2.048-0.853-2.9-0.853V64.116z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M453.716,51.947v-6.312h17.741v6.312h-5.8v35.483h-6.14V51.947H453.716z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M482.89,58.998l0.172,0.398h0.113l0.172-0.398l3.071-13.363h6.026l-6.254,23.997v17.798h-6.142V69.632    l-6.254-23.997h6.026L482.89,58.998z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFFFFF",
    points: "45.087,107.044 42.308,99.69 61.263,99.69 58.866,106.611     "
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.2298,
    strokeMiterlimit: 10,
    d: "M42.134,107.395   c-10.825-5.74-18.504-20.182-18.504-37.089c0-16.831,7.61-31.218,18.357-37.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.2298,
    strokeMiterlimit: 10,
    d: "M66.315,35.207   c0.488,0.409,1.11,0.97,1.455,1.262c7.962,6.735,13.621,19.467,13.662,33.771c0.049,17.157-7.908,31.775-18.986,37.338"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.2298,
    strokeMiterlimit: 10,
    d: "M64.195,88.446    c6.806,1.109,12.758,3.163,17.237,5.852"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.2298,
    strokeMiterlimit: 10,
    d: "M23.341,94.475    c3.721-2.291,8.497-4.134,13.959-5.345"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.2298,
    strokeMiterlimit: 10,
    d: "M81.72,46.114    c-6.894,4.242-17.409,6.95-29.189,6.95c-11.618,0-22.006-2.635-28.901-6.775"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.2298,
    strokeMiterlimit: 10,
    x1: 14.938,
    y1: 70.294,
    x2: 90.124,
    y2: 70.294
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.2298,
    strokeMiterlimit: 10,
    d: "M52.531,107.887"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M46.854,34.645c-17.141,2.785-30.241,17.636-30.267,35.568c-0.029,19.936,16.108,36.121,36.044,36.15       c19.936,0.029,36.121-16.108,36.15-36.044c0.023-15.719-9.494-28.94-23.472-33.902c0,0-1.493-4.013-4.673-6.336       c17.355,2.926,32.898,19.548,32.868,40.297c-0.033,22.629-18.404,40.946-41.033,40.913       c-22.629-0.033-40.946-18.404-40.913-41.033c0.03-20.648,15.332-37.694,35.201-40.497       C46.758,29.761,47.432,31.812,46.854,34.645z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M69.812,58.793c0.084,1.006,0.254,2.019,0.254,3.062c0,10.13-8.212,18.342-18.342,18.342    s-18.342-8.212-18.342-18.342c0-3.799,1.155-7.328,3.133-10.255c0,0,2.904-4.677,5.1-6.817c0,0,1.797-1.947,4.193-6.59    c0,0,2.172,5.017,1.048,11.158c0,0,6.44-4.044,4.867-21.641c0,0,19.02,8.537,11.532,33.099c0,0,4.493-1.048,4.942-8.836    C68.198,51.971,69.557,55.731,69.812,58.793z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M45.451,61.364"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M41.292,89.701c-1.47,0-2.657-1.21-2.657-2.703c0-1.503,1.19-2.703,2.657-2.703h26.072    c0.281-1.136,0.628-1.944,0.628-1.944H38.581c-1.616,0-2.927,2.063-2.927,4.647c0,2.567,1.308,4.647,2.927,4.647h29.412    c0,0-0.326-0.816-0.602-1.944H41.292z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.7002,
    strokeMiterlimit: 10,
    d: "M65.974,83.6c0,0-4.004,3.112,0,6.755"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M43.495,96.251c-1.162,0-2.101-0.957-2.101-2.138c0-1.189,0.941-2.138,2.101-2.138h20.62    c0.222-0.898,0.497-1.537,0.497-1.537H41.35c-1.278,0-2.315,1.631-2.315,3.675c0,2.03,1.034,3.675,2.315,3.675h23.261    c0,0-0.258-0.645-0.476-1.537H43.495z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.3447,
    strokeMiterlimit: 10,
    d: "M63.015,91.426c0,0-3.167,2.461,0,5.342"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F9C815",
    strokeWidth: 1.7011,
    strokeMiterlimit: 10,
    d: "M50.203,107.237"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSflLogoWhite);
export default __webpack_public_path__ + "static/media/SFL-LOGO-WHITE.fb63f639c6450120610182ed4097b2d8.svg";
export { ForwardRef as ReactComponent };